export default {
  create: {
    title: 'Agregar',
    subtitle: 'Usuario',
  },
  edit: {
    title: 'Editar',
    subtitle: 'Usuario',
    button: {
      add: 'Nuevo usuario',
    },
  },
  list: {
    title: 'Usuarios',
    subtitle: 'Lista',
    add: 'Nuevo usuario',
  },
  table: {
    title: 'Usuarios Activos',
    searchPlaceholder: 'Buscar...',
    noContent: 'No hay usuarios registrados todavía.',
    columns: {
      name: 'Nombre',
      email: 'Correo electrónico',
      role: 'Rol',
      options: 'Opciones',
    },
    actions: {
      delete: 'Eliminar',
    },
  },
  delete: {
    title: 'Confirme la eliminación del usuario',
    message: '¿Está seguro de que desea eliminar este usuario?',
  },
  account: {
    title: 'Perfil',

    form: {
      name: {
        label: 'Nombre',
        placeholder: 'Nombre',
      },

      email: {
        label: 'Correo electrónico',
        placeholder: 'Correo electrónico',
        invalid: 'El correo electrónico es obligatorio',
      },

      userType: {
        label: 'Tipo de usuario',
      },

      role: {
        label: 'Rol',
      },

      oldPassword: {
        label: 'Contraseña anterior',
      },

      password: {
        label: 'Contraseña',
        invalid: 'Las contraseñas no coinciden',
      },

      passwordConfirmation: {
        label: 'Confirmar contraseña',
        invalid: 'Las contraseñas no coinciden',
      },

      sendPassword: {
        label: 'Establecer contraseña por correo electrónico',
        options: {
          yes: 'Sí',
        },
      },

      submit: 'Guardar',
    },

    roles: {
      administrator: 'Administrador',
      none: 'Ninguno',
    },
  },
  profile: {
    title: 'Perfil del usuario',
    subtitle: 'Descripción general',
  },
  alert: {
    deleted: 'Usuario eliminado con éxito',
  },
};
